import styled from 'styled-components'
// components
import HeaderOrigin from 'components/UI/Modal/Header'
// utils
import { ellipsis } from 'polished'

export const Wrapper = styled.div`
  padding: 16px 0 16px 16px;
  height: 100%;

  > div {
      height: 100%;
      margin: 0;
  }
`

export const PlanTitle = styled.div`
  ${ellipsis('95%')};
`

export const Header = styled(HeaderOrigin)`
  height: 64px;
`

export const Description = styled.div`
  font-weight: bold;
  padding: 16px 16px 0;
`
